import defineMessages from "../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    title1: {
        id: "intro.embed.1.title",
    },
    title2: {
        id: "intro.embed.2.title",
    },
    description1: {
        id: "intro.embed.1.description",
    },
    description2: {
        id: "intro.embed.2.description",
    },
});

export default messages;
